// Ein Element startet, sobald seine Oberkante ein Zehntel des Fensters über dem unteren Rand ist.
// Früher musste zusätzlich ein Anteil des Elements sichtbar sein, dann kamen hohe Blöcke auf dem Handy
// erst, wenn schon ein Viertel des Bildschirms leer dastand.
const REVEAL_MARGIN = '-10%';

export function initScrollReveal(selector = '.reveal', activeClass = 'active') {
    // Mit data-reveal-margin (z.B. "-30%") startet ein Element erst, wenn seine Oberkante so weit
    // über dem unteren Fensterrand ist. Gut für Abläufe, die man sonst halb ausserhalb des Bildes verpasst.
    const observers = new Map();

    const observerFor = (margin = REVEAL_MARGIN) => {
        if (!observers.has(margin)) {
            observers.set(margin, new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(activeClass);
                        obs.unobserve(entry.target);
                    }
                });
            }, { rootMargin: `0px 0px ${margin} 0px` }));
        }

        return observers.get(margin);
    };

    document.querySelectorAll(selector).forEach(el => observerFor(el.dataset.revealMargin).observe(el));
}
